import { render, staticRenderFns } from "./ClientMailMstModal.vue?vue&type=template&id=65e3f258&scoped=true&"
import script from "./ClientMailMstModal.vue?vue&type=script&lang=js&"
export * from "./ClientMailMstModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientMailMstModal.vue?vue&type=style&index=0&id=65e3f258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e3f258",
  null
  
)

export default component.exports